export default "__VITE_ASSET__BqDgF0z1__"